export default __webpack_public_path__ + "static/media/app2-20.709a7e4c.jpg";